import React from 'react';
import { Tab, Tabs, Typography, Box, Paper } from '@mui/material';

const BookDetailsTabs = () => {
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  // Hardcoded values for description and author details
  const description = `Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec at nunc massa. Nunc ac bibendum tortor. Aenean consectetur augue at magna posuere mattis. Proin eu lobortis arcu, sit amet faucibus libero. Suspendisse cursus ligula eu interdum auctor. In feugiat sollicitudin libero, ultricies faucibus augue vulputate eu. Nullam vehicula bibendum consequat. Nulla nulla arcu, ultricies et massa aliquam, efficitur commodo metus. Etiam vitae commodo ligula. Nunc elementum tellus id massa fermentum porta. Praesent eu sollicitudin nibh, non faucibus leo. In in libero a dolor eleifend egestas. Maecenas suscipit ipsum quis augue rhoncus, vel posuere lorem hendrerit. Nam volutpat est quis arcu mollis ultrices. Ut maximus ultricies lectus, a eleifend diam feugiat ut. Maecenas lobortis mi vel massa bibendum lobortis. Etiam porta ante at elementum mattis. Proin ultricies, nisi sed blandit fringilla, urna odio tempor eros, eget imperdiet ipsum arcu non ante. Nullam iaculis bibendum interdum. Sed ipsum erat, pretium vitae leo sed, sodales condimentum elit. Donec malesuada porta nisi pharetra rutrum. In nec justo velit. Pellentesque habitant morbi tristique senectus et netus et malesuada fames ac turpis egestas. Maecenas nec ligula nisl. Aenean sagittis sapien sit amet nisi sollicitudin elementum. Aenean a aliquet purus. Pellentesque in sagittis dolor. Donec id tempus.`;

  const authorDetails = `John Doe is an accomplished author with several publications in the field of literature. He holds a Master's degree in English Literature from a prestigious university and has received numerous accolades for his literary contributions.John Doe is an accomplished author with several publications in the field of literature. He holds a Master's degree in English Literature from a prestigious university and has received numerous accolades for his literary contributions.John Doe is an accomplished author with several publications in the field of literature. He holds a Master's degree in English Literature from a prestigious university and has received numerous accolades for his literary contributions.John Doe is an accomplished author with several publications in the field of literature. He holds a Master's degree in English Literature from a prestigious university and has received numerous accolades for his literary contributions.John Doe is an accomplished author with several publications in the field of literature. He holds a Master's degree in English Literature from a prestigious university and has received numerous accolades for his literary contributions.`;

  return (
    <Box sx={{ width: '100%' }}>
      <Paper sx={{ p: 2, backgroundColor: '#f0f0f0' }}>
      <Paper sx={{ p: 2, backgroundColor: '#f0f0f0' }}>
        <Tabs
          value={value}
          onChange={handleChange}
          indicatorColor="primary"
          textColor="primary"
          variant="fullWidth"
          aria-label="book details tabs"
        >
          <Tab label="Description" />
          <Tab label="Author Details" />
        </Tabs>
      </Paper>
      <Paper sx={{ p: 2, backgroundColor: '#fafafa' }}>
      <Box sx={{ p: 2 }}>
        {value === 0 && (
          <Typography variant="body1">
            {description}
          </Typography>
        )}
        {value === 1 && (
          <Typography variant="body1">
            {authorDetails}
          </Typography>
        )}
      </Box>
      </Paper>
      </Paper>
    </Box>
  );
};

export default BookDetailsTabs;
